export enum DocumentType {
    ServiceRequestForm = 'SRF',
    Correspondence = 'COR',
    Income = 'INC',
    Claim = 'CLM',
    Enrollment = 'ENR',
    PriorAuth = 'PA',
    Other = 'OTHER',
    AssignmentOfBenefits = 'AOB',
}
